import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock14 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0144 8.16874L7.70117 6.62655V3.50117H6.30117V7.3758L9.23783 9.3336L10.0144 8.16874Z",
			fill: "black",
			fillOpacity: .87
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.701172 7.00117C0.701172 3.52828 3.52828 0.701172 7.00117 0.701172C10.4741 0.701172 13.3012 3.52828 13.3012 7.00117C13.3012 10.4741 10.4741 13.3012 7.00117 13.3012C3.52828 13.3012 0.701172 10.4741 0.701172 7.00117ZM11.9012 7.00117C11.9012 4.28984 9.7125 2.10117 7.00117 2.10117C4.28984 2.10117 2.10117 4.28984 2.10117 7.00117C2.10117 9.7125 4.28984 11.9012 7.00117 11.9012C9.7125 11.9012 11.9012 9.7125 11.9012 7.00117Z",
			fill: "black",
			fillOpacity: .87
		})
	]
});
const ForwardRef = forwardRef(SvgClock14);
export { ForwardRef as ReactComponent };
